<template>
  <div class='ant-upload-picture-card-wrapper'>
    <div class='ant-upload-list ant-upload-list-picture-card' v-if='!image&&imageList[0]'>
      <div class='ant-upload-list-picture-card-container' v-for="(v,k) in imageList" :key='k' @click="clickImg(k)">
        <span>
          <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
            <div class="ant-upload-list-item-info">
                <img  :src="v.indexOf('http')!=-1?v:info.picdomain+'/'+v" class='ant-upload-list-item-image' />
            </div>
            <span class="ant-upload-list-item-actions" @click="delChooseImg(k)">
              <span title="删除文件" tabindex="-1" role="img" aria-label="delete" class="anticon anticon-delete"><svg class="" data-icon="delete" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896" focusable="false">
                  <path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z">
                  </path>
                </svg></span>
            </span>
          </div>
        </span>
      </div>
    </div>
    <div class='ant-upload-list ant-upload-list-picture-card' v-else-if="image">
      <div class='ant-upload-list-picture-card-container' @click="clickImg(0)">
        <span>
          <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
            <div class="ant-upload-list-item-info">
                <img   :src="image.indexOf('http')!=-1?image:info.picdomain+'/'+image"  class='ant-upload-list-item-image'/>
            </div>
            <span class="ant-upload-list-item-actions" @click="delChooseImg(0)">
              <span title="删除文件" tabindex="-1" role="img" aria-label="delete" class="anticon anticon-delete"><svg class="" data-icon="delete" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896" focusable="false">
                  <path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z">
                  </path>
                </svg></span>
            </span>
          </div>
        </span>
      </div>
    </div>
    <div class='ant-upload ant-upload-select ant-upload-select-picture-card' :style="'width:'+size.width+'px;height:'+size.height+'px'" v-if="imageList.length <  max &&!image " @click='choose=true'>
      <span class='ant-upload'>
        <div>
          <plus-outlined />
          <div class="ant-upload-text">选择</div>
        </div>
      </span>
    </div>
  </div>
  <!-- 选择 -->
  <a-modal :keyboard="false" v-model:visible="choose" centered style="width:700px" :width='1300' @ok="handleChoose" @cancel='checkAll=false;search.name=""' destroyOnClose>
    <!-- 头部 -->
    <div class=" m-t-20 s_flex_bian_c m-b-20">
      <div class='s_flex_ali'>
        <span class='m-l-30 mr15 '>
          <a-button type="primary" shape="round" class='m-r-20' @click='uploadVisible=true'>
            <PlusOutlined />
            添加图片
          </a-button>
          大小不超过2M，支持bmp/png/jpeg/jpg/gif格式
        </span>
      </div>
      <a-input-search placeholder="标题" enter-button v-model:value="search.name" @search="onSearch" style="width:300px" />
    </div>
    <!-- 素材内容 -->
    <a-layout id="components-layout-demo-custom-trigger">
      <a-layout-sider  :trigger="null" collapsible style="background: #fff;padding-top:20px">
        <a-menu mode="inline" v-model:selectedKeys="defaultSelected" @click="handleMaterialCate" style="height: 562px;overflow-y: scroll;">
          <a-menu-item key="">
            <span>全部</span>
          </a-menu-item>
          <a-menu-item v-for="v in CateList" :key='v.id'>
            <span>{{v.name}}({{v.list_count}})</span><span class='fr'>
              <DeleteOutlined @click.stop="DelCate(v.id)" />
              <EditOutlined @click.stop="group=v;visible=true" />
            </span>
          </a-menu-item>
        </a-menu>
        <a-button class="m-t-10" type="primary" ghost block @click.stop='visible=true'>
          <PlusOutlined />
          添加分组
        </a-button>
      </a-layout-sider>
      <a-layout>
        <a-layout-header style="background: #fff; padding: 0">
          <a-checkbox v-model:checked="checkAll" @change="onCheckAllChange" class='m-l-25'>
            全选
          </a-checkbox>
          <!--  <a-button type="link" class='m-r-20' @click='changGroup(checkedList)'>
          移动分组
        </a-button>-->
          <a-button type="link" class='m-r-20' @click="productMaterialDel">
            删除
          </a-button>
        </a-layout-header>
        <a-layout-content :style="{ padding: '12px', background: '#fff', minHeight: '280px' }">
          <a-checkbox-group v-model:value="checkedList" @change="onChange" class='width100'>
            <a-spin :spinning="loading">
              <ul class="s_flex_ali librayList" v-if="images.length">
                <li style="width:25%" v-for="(v,k) in images" :key='k'>
                  <div class="content ">
                    <div class="imgContent"><img :src="info.picdomain+'/'+v.file_url" /></div>
                    <!-- <div class="img_content" :style="{backgroundImage: 'url(' + v.host+'/'+(v.video_image_name?v.video_image_name:v.file_name) + ')', backgroundSize:'contain'}"></div>-->
                    <div class='s_omit p-l-5 p-r-5'>
                      <a-checkbox :value="v.media_id" name="type" class=' m-t-8 m-b-10 s_omit width100'>
                        {{v.name}}.{{v.extension}}
                      </a-checkbox>
                    </div>
                  </div>
                  <div class="material_foot">
                    <div class="button-group">
                      <div @click='changName(v)'>改名</div>
                      <div @click="copy(info.picdomain+'/'+v.file_url)">链接</div>
                      <div>
                        <a-dropdown>
                          <a class="ant-dropdown-link" @click="e => e.preventDefault()"> 更多
                            <DownOutlined />
                          </a>
                          <template #overlay>
                            <a-menu>
                              <a-menu-item key="0">
                                <div @click='changGroup(v)'>分组</div>
                              </a-menu-item>
                              <a-menu-item key="1">
                                <div @click='delMaterial(v.id)'>删除</div>
                              </a-menu-item>
                            </a-menu>
                          </template>
                        </a-dropdown>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <a-empty v-if="!images.length" />
            </a-spin>
          </a-checkbox-group>
          <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-modal>
  <!-- 添加分组 -->
  <a-modal  :keyboard="false" title="分组管理" v-model:visible="visible" centered :confirm-loading="confirmLoading" @ok="handleOk" style="width:700px">
    <a-form ref="groupForm" :model="group" :rules="rules" :label-col="{span:4}" :wrapper-col="{span:20}">
      <a-form-item ref="name" label="分组名称" name="name" :rules="[{ required: true, message: '请输入分组名称' },{ max: 10, message: '分组名称不超过10个字符' }]">
        <a-input v-model:value="group.name" />
      </a-form-item>
      <a-form-item ref="id" label="id" name="id" hidden>
        <a-input v-model:value="group.id" />
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 上传图片 -->
  <a-modal  :keyboard="false" title="图片上传" centered v-model:visible="uploadVisible" :confirm-loading="confirmLoading" @ok="handleUpLoad" :width='500'>
    <a-form ref="upLoadForm" :model="upLoad"  :label-col="{span:4}" :wrapper-col="{span:14}">
      <!-- <a-form-item ref="name" label="图片名称" name="name" :rules="[{ required: true, message: '请输入图片名称' },{ max: 10, message: '图片名称不超过10个字符' }]">
        <a-input v-model:value="upLoad.name" />
      </a-form-item> -->
      <a-form-item ref="group_id" label="图片分组" name="group_id" :rules="[{ required: true, message: '请选择分组' }]">
        <a-select v-model:value="upLoad.group_id" ref="select" style="width:200px">
          <a-select-option value='0'>
            <span>默认未分组</span>
          </a-select-option>
          <a-select-option v-for="v in CateList" :value='v.id' :key="v.id">
            <span>{{v.name}}</span>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item ref="image" label="图片" name="image" help='支持jpg/png格式' :rules="[{ required: true, message: '请上传图片' }]">
        <a-upload v-model:fileList="upLoad.image" v-model:value="upLoad.file" name="file" accept='image/jpeg,image/png,image/jpg,image/gif' list-type="picture-card" multiple @preview="handlePreview" :beforeUpload='()=>false'>
          <div v-if='upLoad.image.length == 0'>
            <plus-outlined />
            <div class="ant-upload-text">上传图片</div>
          </div>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 图片预览 -->
  <a-modal  :keyboard="false" :visible="previewVisible" centered :footer="null" @cancel="previewVisible=false">
    <img alt="example" style="width: 100%" :src="previewImage" />
  </a-modal>
  <!-- 修改图片名称 -->
  <a-modal  :keyboard="false" title="修改名称" centered v-model:visible="materialVisible" :confirm-loading="confirmLoading" @ok="handleeditwx_material" style="width:700px">
    <a-form ref='materialForm' :model='material' :label-col="{span:4}" :wrapper-col="{span:20}">
      <a-form-item ref="name" label="素材名称" name="name" :rules="[{ required: true, message: '请输入素材名称' },{ max: 10, message: '分组名称不超过10个字符' }]">
        <a-input v-model:value="material.name" />
      </a-form-item>
      <a-form-item ref="id" label="素材ID" name="id" hidden>
        <a-input v-model:value="material.id" />
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 移动分组-->
  <a-modal  :keyboard="false" title="选择分组" centered v-model:visible="materialGroupVisible" :confirm-loading="confirmLoading" @ok="handleMaterialGroup" style="width:700px">
    <a-form ref='materialGroupForm' :model='materialGroup' :label-col="{span:4}" :wrapper-col="{span:20}">
      <a-form-item ref="group_id" label="素材分组" name="group_id" :rules="[{ required: true, message: '请选择分组' }]">
        <a-select v-model:value="materialGroup.group_id" ref="select" style='width:200px'>
          <a-select-option v-for="v in CateList" :value='v.id' :key="v.id" > 
            <span>{{v.name}}</span>
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- {{materialGroup}} -->
      <a-form-item ref="id" label="素材ID" name="id" hidden>
        <a-input v-model:value="materialGroup.id" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { message, Modal } from "ant-design-vue";
import * as Icon from "@ant-design/icons-vue";
import { inject, onMounted, reactive, ref, toRef, toRefs, watch } from "vue";
import {
  getwx_material,
  getwx_material_cate,
  createwx_material_cate,
  editwx_material,
  delwx_material,
  createwx_material,
  editwx_material_cate,
  delwx_material_cate,
  wx_materialCheck
} from "@/api/public_wx";
import { iscode } from "@/utils/app";
import store from "@/store";
export default {
  name: "wxMaterial",
  components: { ...Icon },
  props: {
    max: {
      type: Number,
    default(){ 
        return 1;
      },
    },
    image: String,
    imageList: {
      type: Array,
      default(){ 
        return [];
      },
    },
    value: Number || Array,
    size: {
      type: Object,
      default(){ 
        return { width: 104, height: 104 };
      },
    },
  },
  setup(props, context) {
    const state = reactive({
      action: "", //上传地址
      headers: {}, //请求头
      checkedList: [], //checkbox 集合
      indeterminate: true,
      checkAll: false,
      plainOptions: [],
      CateList: [], //分组列表
      visible: false, //分组弹框
      images: [], //图片素材
      defaultSelected: ["-1"], //默认选中分组
      fileList: [], //图片列表
      uploadVisible: false, //上传图片弹窗
      loading: false, //加载状态
      confirmLoading: false, //表单提交状态
      previewImage: "",
      previewVisible: false,
      total: 0,
      info: store.state.user.info,
      choose: false,
    });
    // 获取分组信息
    const getGroup = async () => {
      let result = await getwx_material_cate().then((res) => res.data);
      state.CateList = result.data.data;
    };
    // 新建分组
    const groupForm = ref(); //表单
    const group = ref({ name: "", id: null });
    const handleOk = () => {
      state.confirmLoading = true;
      groupForm.value
        .validate()
        .then(async (e) => {
          let data = e;
          let result;
          if (e.id) {
            data.group_id = JSON.stringify(e.id);
            result = await editwx_material_cate(data)
              .then((res) => res.data)
              .catch((error) => error);
          } else {
            result = await createwx_material_cate(data)
              .then((res) => res.data)
              .catch((error) => error);
          }
          if (iscode(result, true)) {
            groupForm.value.resetFields();
            state.visible = false;
            getGroup();
          }
        })
        .catch((error) => console.log(error));
      state.confirmLoading = false;
    };
    // 删除分组
    const DelCate = (id) => {
      Modal.confirm({
        centered: true,
        content: "删除后该分类将无法恢复，您确定要删除该分类吗？",
        onOk: async () => {
          let res = await delwx_material_cate({id}).then((res) => res.data);
          if (iscode(res, true)) {
            getGroup();
            search.value.group_id = "";
            search.value.page = 1;
            initData(search.value);
          }
        },
      });
    };
    // 上传
    const upLoadForm = ref();
    const upLoad = ref({ image: [], name: "", group_id: "", file: "" });
    const handleUpLoad = () => {
      upLoadForm.value
        .validate()
        .then(async (e) => {
          state.confirmLoading = true;
          let formData = new FormData();
          for (let k in e) {
            if (k === "image") {
              for (let i = 0; i < e["image"].length; i++) {
                formData.append("file", e["image"][i].originFileObj);
              }
            } else {
              formData.append(k, e[k]);
            }
          }
          var result = await createwx_material(formData)
            .then((res) => res.data)
            .catch((error) => error);
          state.confirmLoading = false;
             state.uploadVisible = false;
          if (iscode(result, true)) {
            upLoadForm.value.resetFields();
            upLoad.value = {image:[]};
            initData({ ...search.value, page: 1 });
          }
        })
        .catch((error) => console.log(error));
    };
    // 图片预览
    const handlePreview = async (file) => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      state.previewImage = file.url || file.preview;
      state.previewVisible = true;
    };
    const getBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };
    // 搜索
    var search = ref({ limit: 8, group_id: "", name: "", page: 1 });
    const onSearch = () => {
      search.value.page = 1;
      initData(search.value);
    };
    // 全选
    const onCheckAllChange = (e) => {
      Object.assign(state, {
        checkedList: e.target.checked ? state.plainOptions : [],
      });
    };
    const onChange = (checkedList) => {
      state.indeterminate =
        !!checkedList.length && checkedList.length < state.plainOptions.length;
      state.checkAll = checkedList.length === state.plainOptions.length;
    };
    // 获取列表
    const _lodash = inject("_lodash");
    const initData = async (data) => {
      state.images=[]
      state.loading = true;
      var result = await getwx_material(data)
        .then((res) => res.data)
        .catch((error) => error);
      state.loading = false;
      state.checkedList = [];
      state.images = result ? result.data.data : [];
      // 整理数据用于全选
      state.plainOptions = _lodash.map(state.images, "media_id");
      state.total = result.data.total;
    };
    // 点击分组
    const handleMaterialCate = (item, key) => {
      // if(!item.key)return
      state.images = [];
      search.value.group_id = item.key;
      search.value.page = 1;
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    onMounted(() => {
      getGroup();
      initData(search.value);
    });
    // 删除素材
    const delMaterial = (id) => {
      Modal.confirm({
        centered: true,
        content: "删除后将无法恢复，您确定要删除吗？",
        onOk: async () => {
          let ids = id;
          let res = await delwx_material({ ids:JSON.stringify([ids])}).then(
            (res) => res.data
          );
          if (iscode(res, true)) {
            search.value.page = 1;
            initData(search.value);
          }
        },
      });
    };
    // 批量删除
    const productMaterialDel = async () => {
      Modal.confirm({
        centered: true,
        content: "删除后将无法恢复，您确定要删除吗？",
        onOk: async () => {
          let res = await delwx_material({
            ids:JSON.stringify(state.checkedList),
          }).then((res) => res.data);
          if (iscode(res, true)) {
            search.value.page = 1;
            initData(search.value);
          }
        },
      });
    };
    // 复制
    const copy = (link) => {
      var input = document.createElement("input"); // 直接构建input
      input.value = link; // 设置内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      message.success("复制成功");
    };
    // 修改素材名称
    const material = ref(); //存放修改数据
    const materialForm = ref(); //声明表单
    const materialVisible = ref(false);
    const changName = (data) => {
      materialVisible.value = true;
      material.value = data;
    };
    // 提交修改
    const handleeditwx_material = () => {
      materialForm.value.validate().then(async (e) => {
        let result = await editwx_material(e)
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          materialVisible.value = false;
          initData(search.value);
        }
      });
    };
    // 修改素材分组
    const materialGroupForm = ref(); //声明表单
    const materialGroup = ref({ id: "", group_id: "" }); //存放修改数据
    const materialGroupVisible = ref(false);
    const changGroup = (data) => {
      materialGroupVisible.value = true;
      materialGroup.value.id = data.id;
    };
    const handleMaterialGroup = () => {
      state.confirmLoading = true;
      materialGroupForm.value.validate().then(async (e) => {
        let result = await editwx_material(e)
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          materialGroupVisible.value = false;
          initData(search.value);
          getGroup();
        }
        state.confirmLoading = false;
      });
    };
    // 点击对应的图片
    const clickImg = (k) => {
      context.emit("handleclick", k);
    };
    // 删除所选的突破
    const delChooseImg = (k) => {
      if (props.imageList) {
        var imageList = props.imageList;
        imageList.splice(k, 1);
        context.emit("handledel", imageList);
      } else {
        context.emit("handledel", "");
      }
    };
    // 确认选择
    const handleChoose = async() => {
      if (!state.checkedList.length) {
        message.error("请选择图片");
        return;
      }
      if (state.checkedList.length + props.imageList.length > props.max) {
        message.error(
          `最大可选择${props.max}张图片,已选数量:${state.checkedList.length + props.imageList.length}`
        );
        return;
      }
      var imageData ={
        url:[],
        data:[]
      };
      state.images.forEach((v) => {
        if (state.checkedList.includes(v.media_id)) {
          var url =state.info.picdomain+'/'+v.file_url;
          var data=v
          if (props.max > 1) {
            imageData.imageUrl.push(url);
            data.push(v)
          } else {
            imageData.imageUrl = url;
            imageData.data=v
          }
        }
      });
      let result = await wx_materialCheck({thumb_media_id:imageData.data.media_id}).then((res) => res.data).catch((error) => error);
      if (iscode(result)) {
        state.choose = false;
        state.checkedList = [];
        state.checkAll = false;
        context.emit("handlechoose", imageData);
      }else{
        message.error(result.msg);
      }
    };
    return {
      ...toRefs(state),
      onSearch,
      search,
      group,
      handleOk,
      clickImg,
      delChooseImg,
      handleMaterialCate,
      groupForm,
      upLoadForm,
      handleUpLoad,
      upLoad,
      handlePreview,
      pageSizeChange,
      pageCurrentChange,
      DelCate,
      delMaterial,
      onChange,
      onCheckAllChange,
      productMaterialDel,
      copy,
      changName,
      handleeditwx_material,
      materialForm,
      material,
      materialVisible,
      handleMaterialGroup,
      changGroup,
      materialGroup,
      materialGroupForm,
      materialGroupVisible,
      handleChoose,
    };
  },
};
</script>
<style lang="less" scoped>
.librayList {
  border: 1px solid #eee;
  flex-wrap: wrap;
  max-height: 699px;
  overflow: hidden;
  min-width: 100%;
  li {
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding-bottom: 12px;
    &:nth-child(4n) {
      border-right: none;
    }
    &:nth-child(n + 5) {
      border-bottom: 0;
    }
    .content {
      box-sizing: border-box;
      padding: 5px;
      padding-bottom: 0;
      .imgContent {
        min-width:100px;
        height: 150px;
        overflow: hidden;
        margin: 0 auto;
        // background-repeat: no-repeat;
        // background-size: contain;
      }
      img {
        width: 100%;
      }
    }
    .material_foot {
      padding: 0 5px;
      cursor: pointer;
      .button-group {
        width: 100%;
        padding: 8px 0;
        background-color: #f5f5f8;
        font-size: 14px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #05486A;
        display: flex;
        div {
          flex: 1;
          text-align: center;
        }
      }
    }
  }
}
.ant-form-item-control-wrapper {
  width: 60% !important;
  display: inline-block;
}
</style>